import type { PMCConfig } from '@kyruus/types';

import type { Request } from 'Common/types/express';
import { getTokenValue } from 'Common/logging/tokens/interaction';
import { getTrackingPrivacyPreference } from 'Common/utils/cookies';

import { getExistingSearchData } from '../search-id';
import {
  CONSUMER_TRACKING_TOKEN,
  USER_TOKEN,
  SEARCH_TOKEN,
  USER_ID
} from './definitions';
import type { CommonTrackingParams } from './types';

/**
 * Get object of tracking params as they are passed around to apis
 */
export function getCommonTrackingParams({
  config,
  req
}: {
  config: PMCConfig;
  // required on server side
  req?: Request;
}): CommonTrackingParams {
  // token is a multi-part token, so we need to extract only the id that we care about. searchId can be null
  const { searchId } = getExistingSearchData({ req, config });

  const { consent: hasTrackingConsent, type: trackingConsentType } =
    getTrackingPrivacyPreference({ config, req });

  return {
    // search id is a composite token and we only need to send part of it
    search_id_token: searchId,
    user_token: getTokenValue({
      req,
      token: USER_TOKEN,
      hasTrackingConsent
    }),
    tracking_token: getTokenValue({
      req,
      token: CONSUMER_TRACKING_TOKEN,
      hasTrackingConsent
    }),
    search_token: getTokenValue({
      req,
      token: SEARCH_TOKEN,
      hasTrackingConsent
    }),
    user_id: getTokenValue({ req, token: USER_ID, hasTrackingConsent }),
    tracking_consent: hasTrackingConsent,
    tracking_consent_type: trackingConsentType
  };
}
